import { DetailSection } from "@/components/ui/detail-field";
import { useTheme } from "next-themes";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { FilaAjuste, ListaAjustes } from "@/components/ui/modal-secciones";
import { Monitor, Palette } from "lucide-react";
import { limpiarTodosLosFiltros } from "@/lib/filtrosPersistentes";

/** Preferencias de esta sesión del navegador: tema (next-themes) y filtros guardados. */
export function SeccionPreferencias() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const delSistema = (theme ?? "system") === "system";
  const oscuro = resolvedTheme === "dark";

  return (
    <>
      <DetailSection icon={Palette} title="Apariencia">
        <ListaAjustes>
          <FilaAjuste
            htmlFor="pref-sistema"
            titulo="Usar el tema del dispositivo"
            descripcion="Sigue el modo claro u oscuro de tu computadora o teléfono."
          >
            <Switch
              id="pref-sistema"
              checked={delSistema}
              onCheckedChange={(v) => setTheme(v ? "system" : oscuro ? "dark" : "light")}
            />
          </FilaAjuste>
          <FilaAjuste
            htmlFor="pref-oscuro"
            titulo="Modo oscuro"
            descripcion={delSistema ? "Apaga \"Usar el tema del dispositivo\" para elegirlo tú." : "Fondo oscuro en todo el panel."}
          >
            <Switch
              id="pref-oscuro"
              checked={oscuro}
              disabled={delSistema}
              onCheckedChange={(v) => setTheme(v ? "dark" : "light")}
            />
          </FilaAjuste>
        </ListaAjustes>
      </DetailSection>

      <DetailSection icon={Monitor} title="Este navegador">
        <ListaAjustes>
          <FilaAjuste
            titulo="Filtros guardados"
            descripcion="Las pantallas recuerdan tus filtros en este navegador. Bórralos para empezar de cero."
          >
            <Button
              variant="cancel"
              size="compact"
              onClick={() => {
                limpiarTodosLosFiltros();
                toast.success("Filtros guardados borrados");
              }}
            >
              Borrar filtros
            </Button>
          </FilaAjuste>
        </ListaAjustes>
      </DetailSection>
    </>
  );
}
